import * as React from 'react';
import { connect } from 'react-redux';
import { UserInfo } from '../Login/common/defaults';
import {
  getComments,
  getReport,
  setComments,
  setReport,
} from './redux-objects/actions';
import * as urls from '../shared/urls';
import { IComment, IReport } from '../../common/sharedTypes';
import { Button, OverlayTrigger, Popover, Row, Col, CloseButton } from 'react-bootstrap';
import PopoverContent from 'react-bootstrap/PopoverContent';
import PopoverTitle from 'react-bootstrap/PopoverTitle';
import WindowPortal from '../../components/FormIO/MappingComponent/lib/WindowPortal';
import CommentsView from './CommentsView';
import DataTable from '../DataTable';
import '@fortawesome/fontawesome-free/css/all.css';
import 'font-awesome/css/font-awesome.css';
const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');
import './assets/commentPopover.css';

export interface ICommentsButtonProps {
  currentUser: UserInfo;
  reportId: number;
  placement: string;
  reportComments: IComment[];
  className?: string;
  reports?: IReport[];
  report?: IReport;
  getComments?: (url: string) => Promise<IComment[]>;
  getReport?: (url: string) => Promise<void>;
  setComments?: (report: IReport) => Promise<void>;
  setReport?: (report: IReport) => Promise<void>;
}
export interface ICommentsButtonState {
  showComments: boolean;
  showOverlay: boolean;
}
const initialState: ICommentsButtonState = {
  showComments: false,
  showOverlay: false,
};
class CommentsButton extends React.Component<
  ICommentsButtonProps,
  ICommentsButtonState
> {
  windowRef: any;

  public constructor(props: ICommentsButtonProps) {
    super(props);
    this.state = initialState;
  }

  onClosingClick = () => {
    //(this.state.mapComponents.view as any).destroy();
    this.setState({ showComments: false });
    console.log('comments closed');
  };

  componentDidMount() {
    let reportId = this.props.reportId ? this.props.reportId : this.props.report.id
    if (this.props.report) {
      this.props.setComments(this.props.report);
      this.props.setReport(this.props.report);
    }
    if (!this.props.report) {
      this.props.getComments(
        urls.GET_COMMENTS_BY_REPORT_ID + '?reportId=' + reportId
      );
      this.props.getReport(
        urls.GET_REPORT_WITH_KEYWORDS + '?reportId=' + reportId
      );
    }
  }

  onToggle = () => {
    this.setState(state => ({
      showOverlay: !state.showOverlay,
    }));
  }

  public render() {

    // Test code
    //asodfjpqwef -a spowapnvv z/ wopie

    const placement = this.props.placement;
    let theseComments;
    let hasUnviewedComments;
    if(this.props.reportComments.length > 0){
      theseComments = this.props.reportComments.filter(
          (x) => x.reportId == this.props?.reportId ? this.props?.reportId : this.props.report?.id
      );

      hasUnviewedComments =
          this.props.currentUser &&
          theseComments &&
          theseComments.length > 0 &&
          theseComments.some(
              (x) =>
                  x.createdById != this.props.currentUser.id &&
                  ( !x.commentViews || x.commentViews.length == 0 ||
                    !x.commentViews.some((y) => y.viewedById == this.props.currentUser.id)
                  )
          );
    }

    let reportId = this.props.reportId ? this.props.reportId 
      : this.props.report ? this.props.report.id : null;
    return (
      <React.Fragment>
        <OverlayTrigger
          trigger='click'
          key={`commentOverlay${reportId}`}
          placement={
            placement == 'right'
              ? 'right'
              : placement == 'left'
                ? 'left'
                : placement == 'bottom'
                  ? 'bottom'
                  : 'top'
          }
          show={this.state.showOverlay}
          onToggle={this.onToggle}
          overlay={
            <Popover
              id={`popover-positioned-${placement}`}
              className='popComments'
            >
              <PopoverTitle as='h3'>
                <Row>
                  <Col>Comments</Col>
                  <Col className='justify-content-end'>
                    Crashkey:{' '}
                    {(this.props.reports &&
                      this.props.reports.filter(
                        (x) => x.id == reportId
                      )[0] &&
                      this.props.reports.filter(
                        (x) => x.id == reportId
                      )[0].keywords.crashKey) ||
                      'Not yet generated'}
                  </Col>
                  <Col>
                    <CloseButton
                      onClick={this.onToggle}
                    />
                  </Col>
                </Row>
              </PopoverTitle>
              <PopoverContent>
                <CommentsView
                  reportId={reportId}
                />
              </PopoverContent>
            </Popover>
          }
        >
          <Button
            variant={hasUnviewedComments ? 'primary' : 'secondary'}
            className={this.props.className}
            id={`commentBtn${reportId}`}
            key={`commentBtn${reportId}`}
          >
            <i className='fas fa-comment'></i>
          </Button>
        </OverlayTrigger>

        {/* {this.state.showComments && (
          <div className='container-fluid'>
            <CommentsView reportId={1} />
          </div>
        )} */}
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    reportComments: state.Comments.reportComments,
    reports: state.Comments.reports,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  getComments,
  getReport,
  setComments,
  setReport,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsButton);
